import {autoserializeAs} from "dcerialize";
import {ServerImage} from "../ServerImage";

export class TeamMemberImages {
  @autoserializeAs(() => ServerImage)
  public readonly primary?: ServerImage;
  @autoserializeAs(() => ServerImage)
  public readonly flipSide?: ServerImage;
}
